<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="'Lead Closing'" :directory="$t('report')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group row align-items-center">
                    <label for="inputs_semester" class="col-md-12" style="font-size: 16px;font-weight: 600;">
                        Semester
                    </label>
                    <app-input
                        id="inputs_semester"
                        class="col-sm-4"
                        v-model="input_semester"
						@input="setSemesterValue"
                        type="advance-search-select"
                        placeholder="Semester"
						:fetch-url="`report/get-semester`"
						list-value-field="nama"
                    />
                </div>
            </div>
            <div class="col-md-12">
                <app-overlay-loader v-if="preloader" />
                
                <div class="title-report">Lead Closing 2526 T1 - T2</div>
                <div class="card">
                    <div class="table-wrapper" v-if="!preloader" >
                        <table class="table-Report" :class="{ 'loading-opacity': preloader }">
                            <tr>
                                <th rowspan="2" style="min-width: 100px;" >Term</th>
                                <th :colspan="rowData.data_per_centre.length">Centre</th>
                            </tr>
                            <tr>
                                <th
                                    v-for="(item, index) in rowData.data_per_centre"
                                    :key="index" style="min-width: 166px;white-space:nowrap;"
                                >
                                    {{item.centre_name}}
                                </th>
                            </tr>
                            
                            <template v-for="itermPerTerm in rowData.data_per_term">
                                <tr>
                                    <td>{{itermPerTerm.term}}</td>
                                    <td  v-for="(item, index) in itermPerTerm.centre.child"
                                        :key="index" >{{item.total_lead_closing}}</td>
                                </tr>
                            </template>
                            <tr>
                                <td rowspan="2" class="t-foot">Total</td>
                                <td class="t-foot"
                                    v-for="(item, index) in rowData.data_per_centre"
                                    :key="index" style="max-width: 68px;"
                                >
                                    {{item.total_lead_closing}}
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="rowData.data_per_centre.length" class="t-foot">
                                    {{rowData.total_all_term_centre}}
                                </td>
                            </tr>

                        </table>
                    </div>
                    
                </div>
            </div>
            <div class="col-md-12">
                <br>
            </div>
            <div class="col-md-12">
                <div class="title-report">Course Consultant Closing 2526 T1 - T2</div>
                <div class="card">
                    <div class="table-wrapper" v-if="!preloader" >
                        <table class="table-Report" :class="{ 'loading-opacity': preloader }">
                            <tr>
                                <th rowspan="2" style="min-width: 100px;" >Term</th>
                                <th :colspan="rowData.data_per_cc.length">Course Consultant</th>
                            </tr>
                            <tr>
                                <th
                                    v-for="(item, index) in rowData.data_per_cc"
                                    :key="index" style="min-width: 166px;white-space:nowrap;"
                                >
                                    {{item.course_consultan}}
                                </th>
                            </tr>
                            
                            <template v-for="itermPerTerm in rowData.data_per_term">
                                <tr>
                                    <td>{{itermPerTerm.term}}</td>
                                    <td  v-for="(item, index) in itermPerTerm.cc.child"
                                        :key="index" >{{item.total_lead_closing}}</td>
                                </tr>
                            </template>
                            <tr>
                                <td rowspan="2" class="t-foot">Total</td>
                                <td class="t-foot"  v-for="(item, index) in rowData.data_per_cc"
                                    :key="index" >{{item.total_lead_closing}}</td>
                            </tr>
                            <tr>
                                <td :colspan="rowData.data_per_cc.length" class="t-foot">
                                    {{rowData.total_all_term_cc}}
                                </td>
                            </tr>

                        </table>
                    </div>
                    
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";
import { FormMixin } from "./FormMixin.js";

export default {
    extends: CoreLibrary,
    name: "LeadClosing",
    mixins: [FormMixin],
	data() {
		return {
            semesterId: null,
			semesterList : [],
            input_semester:{},
            rowData: {
                data_per_term:[],
                total_all_term_centre : 0,
                total_all_term_cc : 0,
                data_per_cc : [],
                data_per_centre : [],
            },
			preloader: false,
        }
    },
    mounted() {
        this.initSemester();
    },
    methods: {
        async initSemester() {
            const resSemester = await axios.get(
                `/report/get-semester`
            );

            resSemester.data.data.forEach((item) => {
                this.semesterList.push({
                    id: item.id,
                    nama: item.nama,
                });
            });

            if (this.semesterList.length > 0) {
                this.semesterId = this.semesterList[0].id;
                this.input_semester = this.semesterList[0];
                this.loadData(this.semesterId);
            }
        },
        async loadData(semesterId = null) {
            try {
			    this.preloader= true;
                const res = await axios.get(
                    `/report/get-data-lead-closing`,
                    {
                        params: {
                            semester: semesterId
                        }
                    }
                );

                this.rowData = Array.isArray(res.data) ? res.data : res.data || [];
                this.preloader= false;
            } catch (err) {
                this.rowData = {};
                this.preloader= false;
            }
        },
		setSemesterValue(data) {
			this.semesterId = data.id;
            this.input_semester=data;
            this.loadData(this.semesterId);
		},
        formatDate(date) {
            const d = new Date(date);

            const day = String(d.getDate()).padStart(2, '0');

            const month = d.toLocaleDateString('en-GB', {
                month: 'short'
            });

            return `${day}-${month}`;
        },

        // FORMAT RANGE
        formatRange(min, max) {
            return `${this.formatDate(min)}-<br>${this.formatDate(max)}`;
        }
      
    },
}
</script>
<style scoped>
    .table-Report{
        border: 2px solid black;
    }
    .table-Report th{
        white-space: nowrap;
        background: #007bff;
        color: white;
        padding: 10px;
        text-align: center;
        font-size: 16px;
        border: 1px solid black;
    }
    .table-Report td{
        background: white;
        font-size: 14px;
        color: black;
        padding: 10px;
        text-align: center;
        border: 1px solid black;
    }
    .header-weekly{
        white-space: nowrap;
        
    }
    .table-wrapper {
        overflow-x: auto;
        width: 100%;
    }
    .table-Report {
        width: max-content; 
        border-collapse: collapse;
    }
    .lf-0{
        position: sticky;
        left: 0;
    }
    .t-foot{
        font-weight:600;
        background: #dfdfdf !important;
    }
    .title-report{
        font-size: 17px;
        font-weight: 600;
    }

</style>
